export default "__VITE_ASSET__13163977__"